/*
 * @Description: 操作日志路由
 */
import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/pcHome.vue'
const teachingResearchRouter: Array<RouteRecordRaw> = [
	{
		path: '/teachingResearch',
		component: Layout,
		redirect: '/teachingResearch/index',
		children: [
			{
				path: 'index',
				component: () => import(/* webpackChunkName: "teachingResearch" */ '@/views/teachingResearch/index/index.vue'),
				name: 'index',
				meta: { title: '虚拟教研室管理' }
			}
		]
	}
]

export default teachingResearchRouter